<template>
      <div class="footer-social-icons">
        <ul class="social-icons">
          <li class="social-icon">
            <a href="https://facebook.com/enov.news" target="_blank">
              <i class="fa fa-facebook"></i>
            </a>
          </li>
          <li class="social-icon">
            <a href="https://x.com/enov_news" target="_blank">
              <i class="fa fa-twitter"></i>
            </a>
          </li>
        </ul>
      </div>
      <div class="footer__copyright" style="font-size:13px;margin:20px 0px;">
        <span>© Copyright <a href="https://enov.group" target="_blank">ENOV Group</a> - {{ new Date().getFullYear() }}</span> 
      </div>
      <div class="go-top">
        <a class="smoothscroll" title="Back to Top" href="#top"></a>
      </div>
</template>
  